import axios from "axios";
import {
  BASE_URL,
  JOB_TYPE_LIST,
  LOGIN,
  LOGOUT,
  USER,
  REGION_LIST,
  JOB,
  JOB_LIST,
  FORGET_PASSWORD,
  RESET_PASSWORD,
  VALIDATE_UUID_LINK,
  JOB_TIME_LINE,
  RESEND_EMAIL_INVITE,
  QUOTATION_DOWNLOAD,
  TECHNICAL_REPORT,
  QUOTATION,
  QUOTATION_DETAILS,
  CANCEL_JOB,
  EQUIPMENT_MANUAL,
  GET_JOB_MEDIA,
  SERVICE_HISTORY,
  JOB_COMPLETED_OR_REWORK,
  DOWNLOAD_JOB_REPORT,
  VALIDATE_QUOTATION_UUID,
  APPROVE_AND_REJECT_QUOTATION,
  GENERATE_CHECKOUT_ID,
  GET_PAYMENT_STATUS,
  DOWNLOAD_JOB_MEDIA,
  DOWNLOAD_PRODUCT_MANUAL,
  DOWNLOAD_EQUIPMENT_INVOICE,
  REOPEN_JOB,
  DOWNLOAD_PAYMENT_RECEIPT,
  ASSIGN_LOCATION_SUB_USER,
  CUSTOMER_QUOTATION_LIST,
  SEND_OTP,
} from "./apiConstants";

const API = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

const CsvAPI = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "csv/text",
  },
});

API.interceptors.request.use((req) => {
  if (localStorage.getItem("p")) {
    req.headers.token = JSON.parse(localStorage.getItem("p")).token;
  }
  return req;
});

CsvAPI.interceptors.request.use((req) => {
  if (localStorage.getItem("p")) {
    req.headers.token = JSON.parse(localStorage.getItem("p")).token;
  }
  return req;
});

const API_FOR_PDF = axios.create({
  baseURL: BASE_URL,
  responseType: "blob",
});

API_FOR_PDF.interceptors.request.use((req) => {
  if (localStorage.getItem("p")) {
    req.headers.token = JSON.parse(localStorage.getItem("p")).token;
  }
  return req;
});

// Login API
export const user_login = (loginData) => API.post(`${LOGIN}`, loginData);

// Logout API
export const user_logout = () => API.post(LOGOUT);

export const get_user_by_ID = (id) => API.get(`${USER}${id}`);

export const edit_user = (id, bodyData) => API.patch(`${USER}${id}`, bodyData);

export const change_password = (id, bodyData) =>
  API.patch(`${USER}${id}/change-password`, bodyData);

export const job_type_list = (pageNum, filters) =>
  API.get(JOB_TYPE_LIST, {
    params: {
      page: pageNum,
      ...(filters?.length ? { filtersJSON: filters } : {}),
    },
  });

//customer service location's region,city and country
export const region_list = () => API.get(REGION_LIST);

export const job_list = (pageNum, filtersJSON, searchString) =>
  API.get(JOB_LIST, {
    params: {
      page: pageNum,
      ...(searchString ? { searchString } : {}),
      ...(filtersJSON ? { filtersJSON } : {}),
    },
  });
export const get_job_by_ID = (id) => API.get(`${JOB}${id}`);

// forgot password API
export const user_forgot_password = (emailData) =>
  API.post(`${FORGET_PASSWORD}`, emailData);

//reset password
export const reset_password = (emailData) =>
  API.post(`${RESET_PASSWORD}`, emailData);

//validate uuid link
export const validate_uuid = (uuid) => API.get(`${VALIDATE_UUID_LINK}${uuid}`);

// Job time line
export const job_time_line_by_ID = (jobId) =>
  API.get(`${JOB_TIME_LINE}${jobId}`);

// resend email invite to user/customers
export const resend_email_invite = (userID) =>
  API.patch(`${RESEND_EMAIL_INVITE}${userID}`);

//download quotation by quotation id
export const download_quotation_by_ID = (quotationId) =>
  API.get(`${QUOTATION_DOWNLOAD}${quotationId}`, {
    responseType: "blob",
  });

//validate Quotation uuid link
export const validate_quotation_uuid = (uuid) =>
  API.get(`${VALIDATE_QUOTATION_UUID}/${uuid}`);

//Approve and Reject Quotation
export const approve_and_reject_quotation = (uuid, bodyData) =>
  API.post(`${APPROVE_AND_REJECT_QUOTATION}/${uuid}`, bodyData);

// Technical Report
export const technical_report_by_ID = (id) =>
  API.get(`${TECHNICAL_REPORT}${id}`);

//Quotation
export const get_quotation_detail = (id) =>
  API.get(`${QUOTATION_DETAILS}${id}`);

export const update_status_quotation = (body) =>
  API.patch(`${QUOTATION}update-status`, body);

// Cancel Job
export const cancel_job = (jobId, body) =>
  API.patch(`${CANCEL_JOB}/${jobId}`, body);

// Equipment Manual
export const equipmentManual = (jobId) =>
  API.get(`${EQUIPMENT_MANUAL}/${jobId}`);

// Job Media
export const jobMedia = (jobId) => API.get(`${GET_JOB_MEDIA}?jobID=${jobId}`);

// Customer Service History
export const getServiceHistory = (equipmentId) =>
  API.get(`${SERVICE_HISTORY}/${equipmentId}`);

// Job Completed or Rework
export const jobCompletedOrRework = (jobID, bodyData) =>
  API.patch(`${JOB_COMPLETED_OR_REWORK}/${jobID}`, bodyData);

//Download Job Report
export const downloadJobReport = (jobID) =>
  API_FOR_PDF.get(`${DOWNLOAD_JOB_REPORT}/${jobID}`, {
    responseType: "blob",
  });

export const generate_CheckoutID = (bodyData) =>
  API.post(`${GENERATE_CHECKOUT_ID}`, bodyData);

// Get Checkout Id
export const download_payment_receipt = (merchantID) =>
  API_FOR_PDF.get(`${DOWNLOAD_PAYMENT_RECEIPT}/${merchantID}`);

// Get Checkout Id
export const check_payment_status = (bodyData) =>
  API.post(`${GET_PAYMENT_STATUS}`, bodyData);

// download job media
export const download_job_media = (jobMediaID, technicalReportID) =>
  API_FOR_PDF.get(
    `${DOWNLOAD_JOB_MEDIA}/${jobMediaID}?technicalReportID=${technicalReportID}`,
  );

// download product manual
export const download_product_manual = (productDocumentID, type) =>
  API_FOR_PDF.get(
    `${DOWNLOAD_PRODUCT_MANUAL}/${productDocumentID}?type=${type}`,
  );

// download equipment invoice
export const download_equipment_invoice = (equipmentID) =>
  API_FOR_PDF.get(`${DOWNLOAD_EQUIPMENT_INVOICE}/${equipmentID}`);

// reopen job
export const reopen_job = (jobID) => API.patch(`${REOPEN_JOB}/${jobID}`);

//get customer sub user
export const get_sub_user_list = (pageNum, filterParams = {}) =>
  API.get(`${USER}list`, {
    params: {
      page: pageNum,
      ...(filterParams.searchString && {
        searchString: filterParams.searchString,
      }),
      ...(filterParams.filters?.length && {
        filtersJSON: JSON.stringify(filterParams.filters),
      }),
    },
  });

export const add_sub_user = (bodyData) => API.post(`${USER}`, bodyData);

export const get_sub_user_detail_by_id = (id) => API.get(`/user/${id}`);

export const update_sub_user_by_id = (id, bodyData) =>
  API.patch(`${USER}${id}`, bodyData);

//assign location to sub user
export const assign_location_sub_user = (bodyData) =>
  API.post(`${ASSIGN_LOCATION_SUB_USER}`, bodyData);

//get the assign list location of sub user
export const get_list_assign_location = (
  id,
  params,
  filtersJSON,
  searchString,
) =>
  API.get(`${ASSIGN_LOCATION_SUB_USER}list/${id}`, {
    params: {
      ...params,
      ...(searchString ? { searchString } : {}),
      ...(filtersJSON ? { filtersJSON: JSON.stringify(filtersJSON) } : {}),
    },
  });

//customer quotation list
export const get_customer_quotation_list = (pageNum, filtersJSON) =>
  API.get(`${CUSTOMER_QUOTATION_LIST}`, {
    params: {
      page: pageNum,
      ...(filtersJSON ? { filtersJSON } : {}),
    },
  });

//send OTP
export const sendOtp = (bodyData) => API.post(SEND_OTP, bodyData);
